import React from 'react';
import { Logo } from '@/assets/logo';

interface SharedLayoutProps {
  title: string;
  children: React.ReactNode;
}

export function SharedLayout({ title, children }: SharedLayoutProps) {
  return (
    <div className="min-h-screen bg-background py-8 px-4">
      <div className="max-w-2xl mx-auto">
        <div className="bg-white rounded-3xl shadow-sm p-6 md:p-8">
          <div className="flex items-center justify-center mb-6">
            <Logo className="h-24" />
          </div>
          <h2 className="text-2xl font-bold text-primary-dark text-center mb-8">
            {title}
          </h2>
          {children}
        </div>
      </div>
    </div>
  );
}